// extracted by mini-css-extract-plugin
export default {"productGrid":"L5-z","centerLink":"M5-z","productSection":"N5-z","item":"O5-z","ctaButton":"P5-z"};